import React from "react";
import ClapPayments from "../../components/_shared/ClapPayments";

const Payments = () => {
  return <ClapPayments />;
};

export default Payments;
